// extracted by mini-css-extract-plugin
export default {"navPanel":"BackTop_navPanel__4Rtq0","navPanelBack":"BackTop_navPanelBack__4bUKm","navPanelBorder":"BackTop_navPanelBorder__CMcFZ"};